import { Store } from '@webtides/element-js';

const callbacks = new Map();
const sharedObserver = new IntersectionObserver((entries) => {
    for (const entry of entries) {
        callbacks.get(entry.target)?.(entry.isIntersecting);
    }
});

/**
 * @property {boolean} isIntersecting
 */
export default class IntersectionStore extends Store {
    _target = null;

    properties() {
        return {
            isIntersecting: false,
        };
    }

    /**
     * @param {Element} target
     */
    observe(target) {
        this._target = target;
        callbacks.set(target, (isIntersecting) => {
            this.isIntersecting = isIntersecting;
        });
        sharedObserver.observe(target);
    }

    unobserve() {
        if (!this._target) return;
        sharedObserver.unobserve(this._target);
        callbacks.delete(this._target);
        this._target = null;
    }
}
